import { useParams, useLocation } from "react-router-dom";
import { useEffect, useState } from "react";
import { auth } from "../firebase"; // adjust path as needed
import Navbar from '../components/Navbar';

function useQuery() {
  return new URLSearchParams(useLocation().search);
}

function BookQuestionPage() {
  const { bookname } = useParams();
  const query = useQuery();
  const [answer, setAnswer] = useState("");
  const [loading, setLoading] = useState(true);

  const question = query.get("q") || "";

  useEffect(() => {
    const user = auth.currentUser;
    if (!user) {
      setAnswer("⚠️ Please log in to ask questions.");
      setLoading(false);
      return;
    }
    if (!question) {
      setAnswer("No question provided.");
      setLoading(false);
      return;
    }
    fetch("https://api-jrox57cr4q-uc.a.run.app/read-book", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        uid: user.uid,
        bookname: decodeURIComponent(bookname),
        action: "question",
        question: question
      }),
    })
      .then(res => res.json())
      .then(data => {
        if (data.error) setAnswer("⚠️ " + data.error);
        else setAnswer(data.answer || "No answer available.");
        setLoading(false);
      });
  }, [bookname, question]);

  return (
     <>
        <Navbar />
    <div className="min-h-screen flex flex-col items-center bg-blue-50">
      <div className="max-w-xl w-full bg-white p-8 mt-16 rounded-lg shadow-xl">
        <h1 className="text-2xl font-bold mb-4 text-blue-800">❓ Book Q&A</h1>
        <div className="mb-2 text-gray-700 font-medium">Q: {question}</div>
        {loading ? <div>Loading...</div> : <div className="text-gray-800 whitespace-pre-line">{answer}</div>}
      </div>
    </div>
    </>
  );
}

export default BookQuestionPage;
